<div
  *transloco="let t; read: 'credential-selection-tile'"
  class="credential-selection-tile"
  [class.list-view]="viewMode() === 'list'"
  [class.grid-view]="viewMode() === 'grid'"
  role="checkbox"
  cdkMonitorElementFocus
  [attr.tabindex]="isDisabled() ? -1 : 0"
  [attr.aria-checked]="isSelected()"
  [ngClass]="{ selected: isSelected(), disabled: isDisabled() }"
  [accredibleTooltip]="isDisabled() ? t('disabled_selection') : null"
  (keydown.space)="toggleSelection()"
  (click)="toggleSelection()"
  [attr.data-cy]="dataCy()">
  @if (viewMode() === 'grid') {
    <div class="icon-wrapper">
      @if (isSelected()) {
        <accredible-icon data-cy="credential-selected" icon="check" />
      }
    </div>

    <accredible-credential-tile-status [credential]="credential()" />

    <accredible-credential-tile-content class="tile no-hover" [credential]="credential()" />
  } @else {
    <div class="list-item-container">
      <div class="checkbox-wrapper">
        <div class="checkbox" [class.checked]="isSelected()">
          @if (isSelected()) {
            <accredible-icon data-cy="credential-selected" icon="check" />
          }
        </div>
      </div>

      <div class="credential-thumbnail">
        <accredible-credential-tile-content [credential]="credential()" [isListView]="true" />
      </div>

      <div class="content-wrapper">
        <div class="status-badges">
          <accredible-credential-tile-status [credential]="credential()" />
        </div>
      </div>
    </div>
  }
</div>
